import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { GenericTableBody } from 'src/backoffice-app-code/components/tables/GenericTableBody';
import { Retailer } from '../../../models/Retailer';
import { useNavigate } from 'react-router';
import { RetailersRoutes } from 'src/backoffice-app-code/routes/Routes';
import TableButtonWithDetailsIcon from 'src/backoffice-app-code/components/buttons/TableButtonWithDetailsIcon';
import MinioImage from 'src/backoffice-app-code/components/images/MinioImage';
import { combinePaths } from 'src/backoffice-app-code/utils/stringUtils';

interface RowProp {
  retailers: Retailer[] | undefined;
  isLoading: boolean;
}

const RetailersTableBody: React.FC<RowProp> = ({ retailers, isLoading }) => {
  const navigate = useNavigate();

  const rows = () => (
    <>
      {retailers?.map((retailer, index) => (
        <TableRow key={index}>
          <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
            <MinioImage
              disabledEffect
              alt={retailer.logoImage?.alt}
              absolutePath={combinePaths(
                retailer?.logoImage?.endpoint,
                retailer?.logoImage?.relativePath
              )}
              sx={{ borderRadius: 1.5, width: 48, height: 48, mr: 2 }}
            />
          </TableCell>
          <TableCell width={'30%'}>{retailer.name}</TableCell>
          <TableCell width={'30%'}>{retailer.pib}</TableCell>
          <TableCell width={'30%'}>{retailer.mb}</TableCell>
          <TableCell align="justify">
            <TableButtonWithDetailsIcon
              label="Detalji"
              onClick={() => navigate(RetailersRoutes.details + '/' + retailer.id)}
            />
          </TableCell>
        </TableRow>
      ))}
    </>
  );

  return (
    <GenericTableBody
      rows={rows()}
      hasData={retailers !== undefined && retailers.length > 0}
      isLoading={isLoading}
    />
  );
};

export default RetailersTableBody;
